import { useFlag } from '@unleash/proxy-client-react';
import React from 'react';

import { Account } from './components/Account';
import { Application } from './components/Application';
import { FinancialDetails } from './components/FinancialDetails';
import { PrivatePensionContacted } from './components/PrivatePensionContacted';
import { ProductsAndServices } from './components/ProductsAndServices';
import { SecuritiesTransfer } from './components/SecuritiesTransfer';
import { Summary } from './components/Summary';
import { Transactions } from './components/Transactions';
import { Withdrawal } from './components/Withdrawal';

import { CustomerDetailTypes } from '.';

export const CustomerDetailTabsKeys = {
  Summary: '',
  FinancialDetails: 'posicao-detalhada',
  PrivatePensionContacted: 'previdencia',
  Transactions: 'movimentacoes',
  Application: 'aplicacao',
  ProductsAndServices: 'produtos-e-servicos',
  SecuritiesTransfer: 'transferencia-de-valores',
  Withdrawal: 'saque',
  Account: 'cadastro',
} as const;

type KeysOfCustomerDetailTabs =
  (typeof CustomerDetailTabsKeys)[keyof typeof CustomerDetailTabsKeys];

export const customerDetailTabs: Record<KeysOfCustomerDetailTabs, CustomerDetailTabDefinition> = {
  [CustomerDetailTabsKeys.Summary]: {
    label: 'Resumo',
    component: Summary,
  },
  [CustomerDetailTabsKeys.FinancialDetails]: {
    label: 'Posição detalhada',
    component: FinancialDetails,
  },
  [CustomerDetailTabsKeys.PrivatePensionContacted]: {
    label: 'Previdência',
    component: PrivatePensionContacted,
  },
  [CustomerDetailTabsKeys.Transactions]: {
    label: 'Movimentações',
    component: Transactions,
  },
  [CustomerDetailTabsKeys.Application]: {
    label: 'Aplicação',
    component: Application,
    unleashFlag: 'b2bShowApplicationInsideCustomers',
  },
  [CustomerDetailTabsKeys.ProductsAndServices]: {
    label: 'Produtos e serviços',
    component: ProductsAndServices,
  },
  [CustomerDetailTabsKeys.SecuritiesTransfer]: {
    label: 'Transferência de valores',
    component: SecuritiesTransfer,
    unleashFlag: 'b2bEnableSecuritiesTransfer',
  },
  [CustomerDetailTabsKeys.Withdrawal]: {
    label: 'Saque',
    component: Withdrawal,
  },
  [CustomerDetailTabsKeys.Account]: {
    label: 'Cadastro',
    component: Account,
  },
};

export type CustomerDetailAvailableTabs = keyof typeof customerDetailTabs;
export type CustomerDetailTabDefinition = {
  label: string;
  component: React.FC<CustomerDetailTypes.Props>;
  unleashFlag?: string;
};

export const customerDetailTabsKeys = Object.keys(customerDetailTabs);
export const customerDetailsInitialTab = customerDetailTabsKeys[0] as CustomerDetailAvailableTabs;

export const generateTabs = () => {
  const mappedEntries = Object.entries(customerDetailTabs);
  const filteredEntries = mappedEntries.filter(
    ([_, tab]: [string, CustomerDetailTabDefinition]) =>
      !tab.unleashFlag || useFlag(tab.unleashFlag)
  );
  return Object.fromEntries(filteredEntries);
};
